import * as React from 'react';
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import SnackbarAlert from '../common/SnackbarAlert';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Grid,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import request from '../../utils/request';
import LoadingButton from '@mui/lab/LoadingButton';

export default function SelectCompany({
  showModal,
  closeModal,
  policyProductData
}) {
  const [loader, setLoader] = useState(null);
  const [status, setStatus] = useState(false);
  const [companyDatas, setCompanyDatas] = useState([]);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const CompanySchema = Yup.object().shape({
    companyId: Yup.string().required('Company is required')
  });

  useEffect(() => {
    formik.values.companyId = '';
    getPolicyDatas();
  }, [showModal]);

  const getPolicyDatas = async () => {
    request({
      url: 'insurencecompany/getInsurenceCompanyList',
      method: 'post',
      data: {
        orderColumn: 'name',
        orderDirection: 'asc',
        offset: 0,
        limit: null,
      }
    }).then(
      (response) => {
        setCompanyDatas([]);
        setCompanyDatas(response['insurencecompanyData']);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const formik = useFormik({
    initialValues: {
      productId: '',
      companyId: '',
      status: true
    },
    validationSchema: CompanySchema,
    onSubmit: (values) => {
      setLoader(true);
      const method = 'POST';
      values.productId = policyProductData.id;
      request({
        url: 'productCompanyConfiguration/brokerageProdCmp',
        method: method,
        data: values
      })
        .then((response) => {
          if (response['status']) {
            // closeCreateEditForm(true);
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'success',
              message: response['message']
            });
            closeModal();
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: response['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  return (
    <div>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Dialog
        open={showModal}
        onClose={closeModal}
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container spacing={1}>
            <Grid item xs={10}>
              Select Company
            </Grid>
            <Grid item xs={2} display="flex" justifyContent="flex-end">
              <IconButton onClick={closeModal}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12}>
                {/* <FormControl fullWidth size="small" >
                  <InputLabel id="demo-simple-select-standard-label" error={Boolean(errors.companyId)}>
                    Select Company
                  </InputLabel> */}
                  <TextField
                  fullWidth
                   select
                    name="companyId"
                    size="small"
                    label="Select Company"
                    value={formik.values.companyId}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.companyId &&
                      Boolean(formik.errors.companyId)
                    }
                    helperText={
                      formik.touched.companyId &&
                      formik.errors.companyId
                    }
                    
                  >
                    {companyDatas.map((company) => (
                      <MenuItem key={company.id} value={company.id}>
                        {company.name}
                      </MenuItem>
                    ))}
                    </TextField>
                  {/* </Select>
                  
                  <div style={{ color: 'red' }}>
                  <b> {formik.touched.companyId && formik.errors.companyId} </b>
                  </div>
                  <FormHelperText>{}</FormHelperText>
                </FormControl> */}
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={3}
                mt={2}
              >
                <LoadingButton
                  sx={{ mt: { xs: 2, md: 0 } }}
                  loading={loader}
                  variant="contained"
                  type="submit"
                >
                  Save
                </LoadingButton>
                &nbsp;
                <Button
                  sx={{ mt: { xs: 2, md: 0 } }}
                  variant="contained"
                  color="error"
                  onClick={closeModal}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
